module.exports = __webpack_public_path__ + "static/story4-hero-1920x1080-0c6c7b1e3483cd94900dc156fa416cee.jpg";